import { useThree } from "@react-three/fiber"

export const SceneGraph = () => {
  const { scene } = useThree()
  scene.traverse(function (obj) {
    var s = "|___"

    var obj2 = obj

    while (obj2 !== scene) {
      s = "\t" + s

      obj2 = obj2.parent
    }

    console.log(s + obj.name + " <" + obj.type + ">")
  })

  return null
}

export const returnsFloor = name => {
  return Number(name.split("-")[2])
}

export const returnsMaterialType = name => {
  return name.split("-")[4]
}
export const returnsBlockID = block => {
  // console.log(block);
  return block.name.split("-")[3].split("_")[0]
}
export const returnsBlockIDFromName = name => {
  // console.log(block);
  return name.split("-")[3].split("_")[0]
}

export const returnsAptID = name => {
  // console.log(block);
  return Number(name.split("-")[3].split("_")[2])
}
export const returnsPlotNumber = name => {
  // console.log(name.split("-")[3])
  return Number(name.split("-")[3].split("_")[2])
}

export const useReturnsPlotNumber = name => {
  // const apartments = useStore
  // console.log(Number(name.split("-")[3]))
  // console.log(name)
  // const apartments = useStore(state => state.apartments)
  // let t = apartments.filter(ap => ap.Name === name)
  return Number(name.split("-")[3].split("_")[2])
}

export const returnsNumberOfApt = v => {
  return v
}

export function hasNumber(myString) {
  return /\d/.test(myString)
}

export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.platform) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
